"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirwebTicketLegacyActionService = void 0;
class AirwebTicketLegacyActionService {
    constructor(client) {
        this.client = client;
    }
    async useCode(code, action, options = {}) {
        const response = await this.client.http.put('Actions/useCode', {
            code,
            action,
        }, options);
        return response.data;
    }
}
exports.AirwebTicketLegacyActionService = AirwebTicketLegacyActionService;
//# sourceMappingURL=action.service.js.map